<template>
    <b-container fluid class="mt-2 px-1 px-sm-3 pb-3 equipment-list-page">
        <FormTemplateEditor v-if="showTemplateEditor" :key="$route.params.templateId" :template="editorTemplate"
            @close="closeTemplateEditor" />
        <FormFill v-else-if="showFormFill" :key="$route.params.submissionId" :submission="fillSubmission"
            @close="closeFormFill" />
        <b-row v-if="!showTemplateEditor && !showFormFill">
            <b-col cols="">
                <b-row>
                    <b-col cols="">
                        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                            <h2 class="text-left mb-0">{{ $t('formsPage.title') }}</h2>
                            <div class="d-flex d-sm-none justify-content-between justify-content-sm-center flex-wrap">
                                <b-button @click="onAddClick" v-if="activeTab !== 'archived' && allowAddForms"
                                    class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                                    variant="primary">
                                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                                    <p class="mb-0 ml-2 text-white">{{ activeTab === 'templates' ?
                                        $t('formsPage.addTemplate') : $t('formsPage.addForm') }}</p>
                                </b-button>
                                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                                    v-if="selectedRows.length">
                                    <template slot="button-content">
                                        <b-icon class="dots" icon="three-dots"></b-icon>
                                    </template>
                                    <b-dropdown-item-button class="mb-2" @click="confirmBulkDelete">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkDeleteLabel }}</p>
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button class="mb-2" v-if="activeTab === 'forms'"
                                        @click="confirmBulkArchive(true)">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkArchiveLabel }}</p>
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button class="mb-2" v-if="activeTab === 'archived'"
                                        @click="confirmBulkArchive(false)">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkUnarchiveLabel }}</p>
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button v-if="activeTab !== 'templates'"
                                        @click="openBulkDueDateModal">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkDueDateLabel }}</p>
                                    </b-dropdown-item-button>

                                </b-dropdown>

                            </div>
                            <div class="d-none d-sm-flex justify-content-between justify-content-sm-center flex-wrap">
                                <b-button @click="onAddClick" v-if="activeTab !== 'archived'"
                                    class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                                    variant="primary">
                                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                                    <p class="mb-0 ml-2 text-white">{{ activeTab === 'templates' ?
                                        $t('formsPage.addTemplate') : $t('formsPage.addForm') }}</p>
                                </b-button>
                                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                                    v-if="selectedRows.length">
                                    <template slot="button-content">
                                        <b-icon class="dots" icon="three-dots"></b-icon>
                                    </template>
                                    <b-dropdown-item-button class="mb-2" @click="confirmBulkDelete">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkDeleteLabel }}</p>
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button class="mb-2" v-if="activeTab === 'forms'"
                                        @click="confirmBulkArchive(true)">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkArchiveLabel }}</p>
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button class="mb-2" v-if="activeTab === 'archived'"
                                        @click="confirmBulkArchive(false)">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkUnarchiveLabel }}</p>
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button v-if="activeTab !== 'templates'"
                                        @click="openBulkDueDateModal">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ bulkDueDateLabel }}</p>
                                    </b-dropdown-item-button>

                                </b-dropdown>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <div class="data-table team-data-table table-custom-border">
                            <div class="bg-white rounded">
                                <div v-if="!isTableMounted" class="d-flex align-items-center px-3 py-3">
                                    <b-skeleton v-for="n in 2" :key="`task-tab-skeleton-${n}`" width="80px"
                                        height="26px" class="mr-3 mb-0"></b-skeleton>
                                </div>
                                <v-tabs v-else class="team-tabs mb-0" show-arrows v-model="tabIndex">
                                    <v-tab>{{ $t('formsPage.tabForms') }}</v-tab>
                                    <v-tab class="with-border">{{ $t('formsPage.tabArchived') }}</v-tab>
                                    <v-tab>{{ $t('formsPage.tabTemplates') }}</v-tab>
                                </v-tabs>
                            </div>
                            <div class="bg-white pt-3 pt-sm-4 rounded" v-if="!isTableMounted">
                                <div class="table_row">
                                    <div class="px-3 px-sm-4 pb-4"
                                        style="height: calc(100vh - 230px); overflow: hidden;">
                                        <b-skeleton-table :rows="17" :columns="7"
                                            :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                    </div>

                                </div>
                            </div>
                            <div class="bg-white pt-3 pt-sm-4 rounded" v-else>
                                <div class="table_row">
                                    <div class="equipment-border filter-box">
                                        <div class="d-flex mb-4 gap-3 flex-wrap px-3 px-sm-4">
                                            <b-form-group
                                                class="text-left label font-weight-normal search-field mb-0 mr-0">
                                                <b-input-group class="username-input-field">
                                                    <b-form-input type="text"
                                                        :placeholder="activeTab === 'templates' ? $t('formsPage.searchTemplates') : $t('formsPage.search')"
                                                        v-model="filterFields.search" class="unit f-12"
                                                        @keyup.enter="getFormsData()"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button variant="primary" @click="getFormsData()">
                                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                                    stroke="white" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M10 10.5L13 13.5" stroke="white"
                                                                    stroke-width="2" stroke-linecap="round"
                                                                    stroke-linejoin="round" />
                                                            </svg>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                            <div class="ml-auto d-none d-sm-flex align-items-center flex-wrap">
                                                <div class="position-relative">
                                                    <div class="position-absolute notification-badge"
                                                        v-if="activeFiltersCount">
                                                        {{ activeFiltersCount }}
                                                    </div>
                                                    <button class="btn btn-filter-section" @click="openFilterModal">
                                                        <div class="d-flex align-items-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                height="24" viewBox="0 0 24 24" fill="none"
                                                                stroke="currentColor" stroke-width="2"
                                                                stroke-linecap="round" stroke-linejoin="round"
                                                                class="lucide lucide-sliders-horizontal w-4 h-4"
                                                                data-id="element-964">
                                                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                                                <line x1="16" x2="16" y1="18" y2="22"></line>
                                                            </svg>
                                                            <p class="mb-0 ml-2">{{ $t('tasksPage.filters') }}</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <b-table ref="tableRef" class="mt-2" responsive :fields="translatedFields"
                                        :items="items" hover :sticky-header="'calc(100vh - 330px)'"
                                        :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                        :no-local-sorting="true" :busy.sync="isBusy" :show-empty="emptyTable" selectable
                                        select-mode="multi" no-select-on-click @row-selected="onRowSelected">
                                        <template #head(selected)="">
                                            <b-form-checkbox class="pl-0 w-fit-content" @change="selectRows($event)"
                                                v-model="allRowsSelected">
                                            </b-form-checkbox>
                                        </template>
                                        <template #cell(selected)="data">
                                            <b-form-checkbox class="pl-0 w-fit-content"
                                                @change="checked(data.index, data.rowSelected)"
                                                v-model="data.rowSelected">
                                            </b-form-checkbox>
                                        </template>
                                        <template #cell(due_date)="data">
                                            <span>{{
                                                data.value ? moment(data.value).format("ll") : '-' }}</span>
                                        </template>
                                        <template #cell(submitted_at)="data">
                                            <span>{{ data.value ? moment(data.value).format("ll") : '-' }}</span>
                                        </template>

                                        <template #cell(title)="data">
                                            <v-app v-if="data.value && data.value !== 'null'">
                                                <v-tooltip top>
                                                    <template #activator="{ on, attrs }">
                                                        <span class="w-fit-content item-description text-left" v-on="on"
                                                            v-bind="attrs">{{
                                                                data.value
                                                            }}</span>
                                                    </template>{{ formatTooltipText(data.value) }}
                                                </v-tooltip>
                                            </v-app>
                                            <p v-else>-</p>
                                        </template>
                                        <template #cell(description)="data">
                                            <v-app v-if="plainText(data.value)">
                                                <v-tooltip top>
                                                    <template #activator="{ on, attrs }">
                                                        <span class="w-fit-content item-description text-left" v-on="on"
                                                            v-bind="attrs">{{
                                                                plainText(data.value)
                                                            }}</span>
                                                    </template><span>{{ formatTooltipText(plainText(data.value))
                                                    }}</span>
                                                </v-tooltip>
                                            </v-app>
                                            <p v-else>-</p>
                                        </template>
                                        <!-- Both tabs carry a status, so one badge serves the
                                             template's draft/published and the submission's
                                             review states. -->
                                        <template #cell(status)="data">
                                            <span v-if="data.value" class="form-status"
                                                :class="statusClass(data.value)">
                                                {{ statusLabel(data.value) }}
                                            </span>
                                            <span v-else>-</span>
                                        </template>
                                        <template #cell(action)="data">
                                            <div>
                                                <svg v-if="activeTab === 'templates' && allowEditForms"
                                                    @click="openTemplateEditor(data.item)" class="mr-4 cursor-pointer"
                                                    width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                                        fill="#2CCE89" />
                                                </svg>
                                                <svg v-if="activeTab === 'forms'" @click="openFormFill(data.item)" class="cursor-pointer mr-4"
                                                    width="20" height="15" viewBox="0 0 20 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <!-- Hands the template to drivers without opening the
                                                     builder first. -->
                                                <svg v-if="activeTab === 'templates' && allowEditForms && isPublished(data.item.status)"
                                                    @click="openAssignDrawer(data.item)" class="mr-4 cursor-pointer"
                                                    width="20" height="20" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM19 8v6M22 11h-6"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg> 
                                                <svg v-if="activeTab === 'templates' && allowEditForms"
                                                    @click="duplicateTemplate(data.item)" class="mr-4 cursor-pointer"
                                                    width="19" height="19" viewBox="0 0 15 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M9.84375 10.7813V12.8906C9.84375 13.2788 9.52875 13.5938 9.14062 13.5938H3.04688C2.86039 13.5938 2.68155 13.5197 2.54969 13.3878C2.41783 13.2559 2.34375 13.0771 2.34375 12.8906V4.92188C2.34375 4.53375 2.65875 4.21875 3.04688 4.21875H4.21875C4.53286 4.21854 4.84644 4.24446 5.15625 4.29625M9.84375 10.7813H11.9531C12.3412 10.7813 12.6562 10.4663 12.6562 10.0781V7.03125C12.6562 4.24375 10.6294 1.93063 7.96875 1.48375C7.65894 1.43196 7.34536 1.40604 7.03125 1.40625H5.85938C5.47125 1.40625 5.15625 1.72125 5.15625 2.10938V4.29625M9.84375 10.7813H5.85938C5.67289 10.7813 5.49405 10.7072 5.36219 10.5753C5.23033 10.4434 5.15625 10.2646 5.15625 10.0781V4.29625M12.6562 8.4375V7.26563C12.6562 6.70619 12.434 6.16966 12.0384 5.77407C11.6428 5.37849 11.1063 5.15625 10.5469 5.15625H9.60938C9.42289 5.15625 9.24405 5.08217 9.11219 4.95031C8.98033 4.81845 8.90625 4.63961 8.90625 4.45313V3.51563C8.90625 3.23862 8.85169 2.96432 8.74568 2.7084C8.63968 2.45248 8.4843 2.21995 8.28843 2.02407C8.09255 1.8282 7.86002 1.67282 7.6041 1.56682C7.34818 1.46081 7.07388 1.40625 6.79688 1.40625H6.09375"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg v-if="
                                                    activeTab === 'forms' && allowDeleteForms
                                                " @click="showArchivePopup(data.item)"  class="cursor-pointer mr-4"
                                                    width="20" height="17" viewBox="0 0 20 17" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M17.6154 4.40909L17.0385 14.0745C17.0074 14.5955 16.7753 15.0851 16.3897 15.443C16.0041 15.8009 15.4942 16.0002 14.9643 16H5.03569C4.50581 16.0002 3.99589 15.8009 3.6103 15.443C3.22471 15.0851 2.99262 14.5955 2.96154 14.0745L2.38462 4.40909M8.15385 7.81818H11.8462M2.03846 4.40909H17.9615C18.5348 4.40909 19 3.95091 19 3.38636V2.02273C19 1.45818 18.5348 1 17.9615 1H2.03846C1.46523 1 1 1.45818 1 2.02273V3.38636C1 3.95091 1.46523 4.40909 2.03846 4.40909Z"
                                                        stroke="#FF7900" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg @click="confirmDelete(data.item)" v-if="allowDeleteForms" class="cursor-pointer" width="19"
                                                    height="20" viewBox="0 0 19 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000"
                                                        stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </template>
                                    </b-table>
                                    <div class="entries-pagination px-0 px-sm-2">
                                        <div class="d-flex align-items-center flex-wrap">
                                            <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                                <b-form-select v-model="perPage" :options="pageOptions" />
                                            </div>
                                            <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                                            <div class="pagination">
                                                <b-pagination v-model="currentPage" :total-rows="rows"
                                                    :per-page="perPage" aria-controls="my-table"></b-pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal id="modal-filter" centered no-close-on-backdrop no-close-on-esc
            :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block p-3 m-0'"
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('tasksPage.filtersModalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body" v-if="activeTab === 'templates'">
                <b-form-group :label="$t('formsPage.columnStatus')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="templateStatusOptions"
                        v-model="filterFields.status" @change="onFilterChange"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.columnAccess')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="accessModeOptions"
                        v-model="filterFields.access_mode" @change="onFilterChange"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.filterActive')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="yesNoOptions" v-model="filterFields.is_active"
                        @change="onFilterChange"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.filterApprovals')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="yesNoOptions"
                        v-model="filterFields.require_approvals" @change="onFilterChange"></b-form-select>
                </b-form-group>
            </div>
            <div class="body" v-else>
                <b-form-group :label="$t('formsPage.columnStatus')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="submissionStatusOptions"
                        v-model="filterFields.status" @change="onFilterChange"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.columnForm')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="templateFilterOptions"
                        v-model="filterFields.template" @change="onFilterChange"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.columnDriverUser')" class="text-left label mb-0">
                    <v-select class="bg_white w-100 f-12 mb-3" v-model="filterFields.assigned_to" :options="nameOptions"
                        item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchUsers"
                        @input="onFilterChange">
                        <span slot="no-options">{{ $t('tasksPage.searchUser') }}</span>
                    </v-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.columnRequester')" class="text-left label mb-0">
                    <v-select class="bg_white w-100 f-12 mb-3" v-model="filterFields.requester" :options="nameOptions"
                        item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchUsers"
                        @input="onFilterChange">
                        <span slot="no-options">{{ $t('tasksPage.searchUser') }}</span>
                    </v-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.columnApprover')" class="text-left label mb-0">
                    <v-select class="bg_white w-100 f-12 mb-3" v-model="filterFields.approver" :options="nameOptions"
                        item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchUsers"
                        @input="onFilterChange">
                        <span slot="no-options">{{ $t('tasksPage.searchUser') }}</span>
                    </v-select>
                </b-form-group>
                <b-form-group :label="$t('formsPage.columnDate')" class="text-left label mb-0">
                    <date-picker v-model="filterFields.date" :formatter="momentFormat" range :range-separator="' - '"
                        class="date-picker-custom f-12 w-100 mb-3" :placeholder="$t('formsFill.selectDate')"
                        @change="onFilterChange"></date-picker>
                </b-form-group>
                <b-form-group :label="$t('formsPage.filterOverdue')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="yesNoOptions" v-model="filterFields.overdue"
                        @change="onFilterChange"></b-form-select>
                </b-form-group>
            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('tasksPage.reset')
                        }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block @click="$bvModal.hide('modal-filter')">{{
                        $t('tasksPage.close') }}</b-button>
                </div>
            </template>
        </b-modal>
        <b-modal id="modal-start-form" centered no-close-on-backdrop no-close-on-esc
            :footer-class="'d-block border-0 pt-0 pb-3 m-0'" :body-class="'px-3 pt-2'"
            :header-class="'align-items-center'">
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('formsPage.startForm') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <b-form-group :label="$t('formsPage.formLabel')" class="text-left select_arrow label mb-3">
                <b-form-select class="input f-12" :options="templateOptions" v-model="newForm.template"></b-form-select>
                <p v-if="startFormError" class="field-error">{{ startFormError }}</p>
            </b-form-group>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                    <b-button class="mx-0 h-40px w-100px m-0 mr-3" variant="secondary"
                        @click="$bvModal.hide('modal-start-form')">{{ $t('tasksPage.close') }}</b-button>
                    <b-button class="mx-0 mb-0 h-40px px-3 m-0" variant="primary" @click="startForm">{{
                        $t('formsPage.startForm') }}</b-button>
                </div>
            </template>
        </b-modal>
        <b-modal id="modal-bulk-due-date" centered no-close-on-backdrop no-close-on-esc
            :footer-class="'d-block border-0 pt-0 pb-3 m-0'" :body-class="'px-3 pt-2'"
            :header-class="'align-items-center'">
            <template #modal-header="{ close }">
                <h5 class="modal-title">{{ $t('formsPage.setDueDate') }}</h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <b-form-group :label="$t('formsPage.columnDueDate')" class="text-left label mb-0">
                <date-picker v-model="bulkDueDate" :formatter="momentFormat" class="date-picker-custom f-12 w-100"
                    :placeholder="$t('formsFill.selectDate')"></date-picker>
                <p v-if="bulkDueDateError" class="field-error">{{ bulkDueDateError }}</p>
            </b-form-group>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                    <b-button class="mx-0 h-40px w-100px m-0 mr-3" variant="secondary"
                        @click="$bvModal.hide('modal-bulk-due-date')">{{ $t('tasksPage.close') }}</b-button>
                    <b-button class="mx-0 mb-0 h-40px px-3 m-0" variant="primary" @click="saveBulkDueDate">{{
                        $t('formsPage.save') }}</b-button>
                </div>
            </template>
        </b-modal>
        <!-- The same drawer the builder uses, so assigning works the same from
             either place. -->
        <AssignDriversDrawer v-model="assignDrawer" :template-id="assignTemplateId" @assigned="getFormsData" />
        <DeleteModal v-if="showBulkDeletePopup" :message="bulkDeleteMessage" @confirm="runBulkDelete($event)" />
        <DeleteModal v-if="bulkArchiving !== null" :message="bulkArchiveMessage"
            :removeMessage="bulkArchiving ? $t('formsPage.archive') : $t('formsPage.unarchive')"
            @confirm="runBulkArchive($event)" />
        <DeleteModal v-if="showDeletePopup" :message="deleteMessage" @confirm="deleteRecord($event)" />
        <DeleteModal v-if="recordToArchive" :message="archiveMessage" :removeMessage="$t('formsPage.archive')"
            @confirm="archiveRecord($event)" />
    </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DeleteModal from "@/components/DeleteModal.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { formStatusKey, formStatusTone, isPublished } from "@/services/formStatus";
import FormTemplateEditor from "@/components/Forms/FormTemplateEditor.vue";
import FormFill from "@/components/Forms/FormFill.vue";
import AssignDriversDrawer from "@/components/Forms/AssignDriversDrawer.vue";

// Filters outlive the visit. Forms and Archived ask the same questions, so they
// share one saved set; templates have their own.
const SUBMISSION_FILTERS_KEY = "formsFilters:submissions";
const TEMPLATE_FILTERS_KEY = "formsFilters:templates";
export default {
    name: "Forms",
    components: { vSelect, FormTemplateEditor, FormFill, DeleteModal, DatePicker, AssignDriversDrawer },
    data() {
        const tab = ['forms', 'archived', 'templates'].includes(this.$route.query.tab)
            ? this.$route.query.tab
            : 'forms'
        return {
            moment,
            showDeletePopup: false,
            formTemplates: [],
            newForm: { template: null },
            startFormError: '',
            recordToDelete: null,
            // The row waiting on the archive confirmation.
            recordToArchive: null,
            // The template the assign drawer is open for.
            assignDrawer: false,
            assignTemplateId: null,
            // Bulk actions: the ticked rows act together.
            showBulkDeletePopup: false,
            // true = archiving, false = unarchiving, null = no confirmation open.
            bulkArchiving: null,
            bulkDueDate: null,
            bulkDueDateError: '',
            // The row being edited, or an empty object for a new template.
            activeTab: tab,
            tabKeys: ['forms', 'archived', 'templates'],
            countries: [],
            selectedRows: [],
            allRowsSelected: false,
            showTaskDeletePopup: false,
            showTaskMultipleUpdatePopup: false,
            taskData: null,
            showTaskUpdatePopup: false,
            openCount: 0,
            deleteMultipleTasksModal: false,
            completedCount: 0,
            allowAddTask: false,
            rows: 1,
            emptyTable: false,
            positionText: "",
            taskID: null,
            sortBy: undefined,
            sortDesc: undefined,
            isBusy: false,
            nameOptions: [],
            isTableMounted: false,
            perPage: 25,
            currentPage: 1,
            items: [],
            filterFields: this.savedFilters(tab),
            momentFormat: {
                stringify: (date) => (date ? moment(date).format("ll") : ""),
                parse: (value) => (value ? moment(value).toDate() : null),
            },
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            "company",
            "userCompany",
            "rolePermissions",
            "user",
            "allTeamMembers"
        ]),
        allowAddForms() {
            return this.rolePermissions && this.rolePermissions['Forms'] && this.rolePermissions['Forms'][2].allow
        },
        allowEditForms() {
            return this.rolePermissions && this.rolePermissions['Forms'] && this.rolePermissions['Forms'][1].allow
        },
        allowDeleteForms() {
            return this.rolePermissions && this.rolePermissions['Forms'] && this.rolePermissions['Forms'][3].allow
        },
        // The builder lives on its own route, so a template is linkable and the
        // back button leaves it.
        showTemplateEditor() {
            return !!this.$route.params.templateId
        },
        showFormFill() {
            return !!this.$route.params.submissionId
        },
        fillSubmission() {
            const submissionId = this.$route.params.submissionId
            return submissionId ? { id: submissionId } : {}
        },
        editorTemplate() {
            const templateId = this.$route.params.templateId
            // "new" is a template that doesn't exist yet — the editor starts blank.
            // Anything else is the API's own id, passed through as it is: a uuid
            // through Number() is NaN, which reads as "no template" and quietly
            // skips the fetch.
            return !templateId || templateId === 'new' ? {} : { id: templateId }
        },
        tabIndex: {
            get() {
                return Math.max(this.tabKeys.indexOf(this.activeTab), 0);
            },
            set(index) {
                const tab = this.tabKeys[index] || this.tabKeys[0];
                if (tab === this.activeTab) return;
                this.activeTab = tab;
                this.currentPage = 1;
                // Forms and Archived share a saved set; templates have their own.
                this.filterFields = this.savedFilters(tab);
                // ?tab= keeps the choice in the URL, so a refresh or a shared
                // link opens on the same tab.
                this.syncTabQuery(tab);
                this.getFormsData();
            },
        },
        translatedFields() {
            if (this.activeTab === 'templates') {
                return [
                    { key: "name", label: this.$t('formsPage.columnName'), sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true },
                    { key: "status", label: this.$t('formsPage.columnStatus'), sortable: true, thClass: 'font-table-weight-bold' },
                    { key: "access", label: this.$t('formsPage.columnAccess'), sortable: true, thClass: 'font-table-weight-bold' },
                    { key: "action", label: this.$t('formsPage.columnAction'), sortable: false, thClass: 'font-table-weight-bold' },
                ];
            }

            return [
                { key: "selected", label: '', thClass: 'font-table-weight-bold', thStyle: { minWidth: "20px", width: "20px" } },
                { key: "assigned_to", label: this.$t('formsPage.columnDriverUser'), sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true },
                { key: "form", label: this.$t('formsPage.columnForm'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "assigned_by", label: this.$t('formsPage.columnRequester'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "reviewed_by", label: this.$t('formsPage.columnApprover'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "submitted_at", label: this.$t('formsPage.columnSubmittedAt'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "due_date", label: this.$t('formsPage.columnDueDate'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "status", label: this.$t('formsPage.columnStatus'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "action", label: this.$t('formsPage.columnAction'), sortable: false, thClass: 'font-table-weight-bold', tdClass: 'text-right' },
            ];
        },
        // Only published forms can be started, which is exactly what /options/ returns.
        templateOptions() {
            return [{ value: null, text: this.$t('formsPage.selectForm') }].concat(
                this.formTemplates.map((item) => ({ value: item.id, text: item.name }))
            )
        },
        templateStatusOptions() {
            return [
                { value: null, text: this.$t('formsPage.filterAny') },
                { value: 'draft', text: this.$t('formsPage.status_draft') },
                { value: 'published', text: this.$t('formsPage.status_published') },
            ]
        },
        accessModeOptions() {
            return [
                { value: null, text: this.$t('formsPage.filterAny') },
                { value: 'all', text: this.$t('formsEditor.accessAll') },
                { value: 'specific', text: this.$t('formsEditor.accessSpecific') },
                { value: 'tags', text: this.$t('formsEditor.accessTags') },
                { value: 'none', text: this.$t('formsEditor.accessNone') },
            ]
        },
        submissionStatusOptions() {
            return [{ value: null, text: this.$t('formsPage.filterAny') }].concat(
                ['not_started', 'in_progress', 'needs_review', 'changes_requested', 'approved', 'denied', 'completed']
                    .map((status) => ({ value: status, text: this.$t(`formsPage.status_${status}`) }))
            )
        },
        yesNoOptions() {
            return [
                { value: null, text: this.$t('formsPage.filterAny') },
                { value: 'true', text: this.$t('documentsPage.yes') },
                { value: 'false', text: this.$t('documentsPage.no') },
            ]
        },
        templateFilterOptions() {
            return [{ value: null, text: this.$t('formsPage.filterAny') }].concat(
                this.formTemplates.map((item) => ({ value: item.id, text: item.name }))
            )
        },
        // Only the keys the active tab actually sends count towards the badge.
        filterKeys() {
            return this.activeTab === 'templates'
                ? ['status', 'access_mode', 'is_active', 'require_approvals']
                : ['status', 'template', 'assigned_to', 'requester', 'approver', 'date', 'overdue', 'archived']
        },
        archiveMessage() {
            const name = this.recordToArchive ? this.recordToArchive.name || this.recordToArchive.form : ''
            return this.$t('formsPage.confirmArchive', { name })
        },
        // "Delete 25 form(s)" — the count comes from the ticked rows, the noun
        // from whichever tab they were ticked on.
        bulkDeleteLabel() {
            const count = this.selectedRows.length
            return this.activeTab === 'templates'
                ? this.$t('formsPage.bulkDeleteTemplates', { count })
                : this.$t('formsPage.bulkDeleteForms', { count })
        },
        bulkArchiveLabel() {
            return this.$t('formsPage.bulkArchive', { count: this.selectedRows.length })
        },
        bulkUnarchiveLabel() {
            return this.$t('formsPage.bulkUnarchive', { count: this.selectedRows.length })
        },
        bulkDueDateLabel() {
            return this.$t('formsPage.bulkDueDate', { count: this.selectedRows.length })
        },
        bulkDeleteMessage() {
            const count = this.selectedRows.length
            return this.activeTab === 'templates'
                ? this.$t('formsPage.confirmBulkDeleteTemplates', { count })
                : this.$t('formsPage.confirmBulkDeleteForms', { count })
        },
        bulkArchiveMessage() {
            const count = this.selectedRows.length
            return this.bulkArchiving
                ? this.$t('formsPage.confirmBulkArchive', { count })
                : this.$t('formsPage.confirmBulkUnarchive', { count })
        },
        deleteMessage() {
            const name = this.recordToDelete ? this.recordToDelete.name || this.recordToDelete.form : ''
            return this.activeTab === 'templates'
                ? this.$t('formsPage.confirmDeleteTemplate', { name })
                : this.$t('formsPage.confirmDeleteForm', { name })
        },
        activeFiltersCount() {
            return this.filterKeys.reduce((count, key) => {
                const value = this.filterFields[key]
                if (Array.isArray(value)) return count + (value.length ? 1 : 0)
                return count + (value !== '' && value !== null && value !== undefined ? 1 : 0)
            }, 0)
        },
    },
    methods: {
        ...mapActions([
            "setNotification",
            "setLoader",
            "getAllTasks",
            "getFormTemplates",
            "duplicateFormTemplate",
            "archiveFormSubmission",
            "bulkFormSubmissions",
            "deleteFormTemplate",
            "deleteFormSubmission",
            "deleteTaskData",
            "getAllTags",
            'updateTaskData',
            "deleteBulkTasks",
            "getAllTeamMembers",
            "updateBulkTasks",
            "getUserForms",
            "getFormTemplateOptions",
            "startFormSubmission"
        ]),

        onRowSelected(items) {
            this.selectedRows = items
        },
        async duplicateTemplate(template) {
            try {
                this.setLoader(true);
                await this.duplicateFormTemplate(template.id);
                await this.getFormsData();
                await this.setNotification({
                    msg: this.$t("formsPage.templateDuplicated"),
                    type: "success",
                    color: "green",
                });
            } catch (error) {
                await this.setNotification({
                    msg: typeof error === "string" ? error : error.error || this.$t("formsPage.duplicateFailed"),
                    type: "error",
                    color: "red",
                });
            } finally {
                this.setLoader(false);
            }
        },
        onAddClick() {
            if (this.activeTab === "templates") this.openTemplateEditor(null);
            else this.openStartFormModal();
        },
        async openStartFormModal() {
            this.newForm = { template: null }
            this.startFormError = ''
            this.$bvModal.show('modal-start-form')
            await this.loadTemplateOptions()
        },
        // Sending just the template asks who it may be started for; the row is
        // is for; the API records whoever types it as `filled_by`.
        async startForm() {
            if (!this.newForm.template) {
                this.startFormError = this.$t('formsPage.formRequired')
                return
            }
            const payload = { template: this.newForm.template }
            try {
                this.setLoader(true)
                const submission = await this.startFormSubmission(payload)
                this.$bvModal.hide('modal-start-form')
                await this.setNotification({
                    msg: this.$t('formsPage.formStarted'),
                    type: "success",
                    color: "green",
                })
                // The row exists now, so go straight to filling it in.
                if (submission && submission.id) this.openFormFill(submission)
                else await this.getFormsData()
            }
            catch (e) {
                this.startFormError = typeof e === 'string' ? e : (e && e.error) || this.$t('formsPage.startFormFailed')
            }
            finally {
                this.setLoader(false)
            }
        },
        openAssignDrawer(template) {
            this.assignTemplateId = template && template.id ? template.id : null
            this.assignDrawer = true
        },
        openTemplateEditor(template) {
            this.$router.push({
                name: "FormTemplateEditor",
                params: { templateId: template && template.id ? `${template.id}` : "new" },
            });
        },
        openFormFill(item) {
            this.$router.push({ name: "FormFill", params: { submissionId: `${item.id}` } });
        },
        closeFormFill() {
            this.backToList("forms");
        },
        closeTemplateEditor() {
            this.backToList("templates");
        },
        // getFormsData() sits out while the editor or the fill screen is up, so
        // the tab being returned to has to ask for its own rows once the route
        // is back on the list — otherwise it lands on the skeleton.
        async backToList(tab) {
            this.activeTab = tab;
            this.currentPage = 1;
            await this.$router.push({ name: "Forms", query: { tab } }).catch(() => { });
            await this.getFormsData();
        },
        // ?tab= belongs to the list and nothing else. The router-view is keyed on
        // the full path, so this component remounts on the editor and fill routes
        // too — without this guard it stamps the tab onto their URLs as well.
        syncTabQuery(tab) {
            if (this.showTemplateEditor || this.showFormFill) return;
            if (this.$route.query.tab === tab) return;
            this.$router.replace({ query: { ...this.$route.query, tab } }).catch(() => { });
        },
        // Descriptions come from a rich-text editor: drop the tags and turn the
        // entities back into characters so the cell shows readable text.
        plainText(value) {
            if (!value || value === "null") return "";
            const holder = document.createElement("div");
            holder.innerHTML = `${value}`.replace(/<\/(p|div|br|li|h[1-6])>/gi, " ");
            return (holder.textContent || "").replace(/\s+/g, " ").trim();
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        async setBulkDelete() {
            let deletePermission = true
            this.selectedRows.map((item => {
                if (!this.checkDeleteStatus(item)) {
                    deletePermission = false
                }
            }))
            if (deletePermission) this.deleteMultipleTasksModal = true;
            else {
                await this.setNotification({
                    msg: this.$t('tasksPage.noDeletePermission'),
                    type: "error",
                    color: "red",
                });
            }
        },
        async searchUsers(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            await this.getAllTeamMembers(url);
            this.allTeamMembers.map((member) => {
                options.push({
                    id: `${member.id}`,
                    label: member.user.first_name + ' ' + member.user.last_name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        checkDeleteStatus(data) {
            return data?.created_by?.id === this.user?.team_member?.id
        },
        async deleteTaskItems(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteBulkTasks({ task_ids: this.selectedRows.map(item => item.id) })
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('tasksPage.tasksDeleted'),
                        type: "success",
                        color: "green",
                    })
                    await this.getFormsData();
                    this.$refs.tableRef.clearSelected()
                    this.allRowsSelected = false
                    this.deleteMultipleTasksModal = false;
                } catch (e) {
                    this.deleteMultipleTasksModal = false;
                    this.setLoader(false)
                    await this.setNotification({
                        msg: e,
                        type: "error",
                        color: "red",
                    });
                }
            }
            else {
                this.deleteMultipleTasksModal = false
                this.$refs.tableRef.clearSelected();
                this.allRowsSelected = false
                this.selectedRows = []
            }
        },
        async updateMultipleTasks(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.updateBulkTasks(
                        {
                            "task_ids": this.selectedRows.map(item => item.id),
                            "status": "Completed"
                        }
                    )
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('tasksPage.tasksUpdated'),
                        type: "success",
                        color: "green",
                    })
                    await this.getFormsData();
                    this.$refs.tableRef.clearSelected()
                    this.allRowsSelected = false
                    this.showTaskMultipleUpdatePopup = false;
                } catch (e) {
                    this.showTaskMultipleUpdatePopup = false;
                    this.setLoader(false)
                    await this.setNotification({
                        msg: e,
                        type: "error",
                        color: "red",
                    });
                }
            }
            else {
                this.showTaskMultipleUpdatePopup = false
                this.$refs.tableRef.clearSelected();
                this.allRowsSelected = false
                this.selectedRows = []
            }
        },
        selectRows(checked) {
            if (checked) {
                this.$refs.tableRef.selectAllRows()
            }
            else {
                this.$refs.tableRef.clearSelected()
                this.allRowsSelected = false
            }
        },
        checked(index, checked) {
            let tableRef = this.$refs.tableRef
            if (checked === true) tableRef.selectRow(index)
            else tableRef.unselectRow(index)
        },
        async updateTask(status) {
            if (status) {
                try {
                    await this.updateTaskData({ taskId: this.taskID, payload: { status: 'Completed' } })
                    await this.setNotification({
                        msg: this.$t('tasksPage.taskUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.taskID = null
                    this.showTaskUpdatePopup = false;
                    await this.getFormsData()
                }
                catch (error) {
                    this.taskID = null
                    this.showTaskUpdatePopup = false;
                    if (typeof error === "object" && error.error) {
                        await this.setNotification({
                            msg: error.error,
                            type: "error",
                            color: "red",
                        });
                    }
                }
            }
            else this.showTaskUpdatePopup = false
        },
        async deleteTask(status) {
            if (status) {
                try {
                    await this.deleteTaskData(`${this.taskID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('tasksPage.taskDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.taskID = null
                    this.showTaskDeletePopup = false;
                    await this.getFormsData()
                }
                catch (error) {
                    this.taskID = null
                    this.showTaskDeletePopup = false;
                    if (typeof error === "object" && error.error) {
                        await this.setNotification({
                            msg: error.error,
                            type: "error",
                            color: "red",
                        });
                    }
                }
            }
            else this.showTaskDeletePopup = false
        },
        showTaskDeletePopupModal(id) {
            this.showTaskDeletePopup = true;
            this.taskID = id;
        },
        showTaskUpdatePopupModal(id) {
            this.showTaskUpdatePopup = true;
            this.taskID = id;
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },

        async setTaskType(type = "") {
            this.taskType = type
            this.currentPage = 1
            this.resetFilterFields()
        },
        async getTaskNewData(id = null) {
            this.allowAddTask = false
            await this.getFormsData()
            if (id) {
                this.taskID = id
            }
        },
        async resetFilterFields() {
            this.selectedRows = []
            this.allRowsSelected = false
            if (this.$refs.tableRef) this.$refs.tableRef.clearSelected()
            this.filterFields = this.emptyFilters()
            localStorage.removeItem(this.filterStorageKey())
            this.currentPage = 1
            await this.getFormsData();
        },
        setTaskData(data) {
            this.taskData = data
            this.allowAddTask = true
        },
        filterStorageKey(tab) {
            return (tab || this.activeTab) === 'templates' ? TEMPLATE_FILTERS_KEY : SUBMISSION_FILTERS_KEY
        },
        // Whatever this tab was last filtered by, on top of the empty shape so a
        // key added later still has a value.
        savedFilters(tab) {
            const empty = this.emptyFilters()
            try {
                const saved = JSON.parse(localStorage.getItem(this.filterStorageKey(tab)) || 'null')
                if (!saved || typeof saved !== 'object') return empty
                // The picker wants Dates back, not the strings they were stored as.
                const date = Array.isArray(saved.date) && saved.date[0] && saved.date[1]
                    ? [new Date(saved.date[0]), new Date(saved.date[1])]
                    : null
                const valid = date && !date.some((entry) => Number.isNaN(entry.getTime()))
                return { ...empty, ...saved, date: valid ? date : null }
            }
            catch (e) {
                // A half-written value is no reason to break the page.
                console.log(e)
                return empty
            }
        },
        rememberFilters() {
            localStorage.setItem(this.filterStorageKey(), JSON.stringify(this.filterFields))
        },
        // One shape for both tabs; each tab only sends the keys it uses.
        emptyFilters() {
            return {
                search: '',
                status: null,
                access_mode: null,
                is_active: null,
                require_approvals: null,
                template: null,
                assigned_to: null,
                requester: null,
                approver: null,
                date: null,
                archived: null,
                overdue: null,
            }
        },
        async openFilterModal() {
            this.$bvModal.show('modal-filter')
            // The Form dropdown lists published templates; fetch them once.
            if (this.activeTab !== 'templates' && !this.formTemplates.length) await this.loadTemplateOptions()
        },
        async loadTemplateOptions() {
            try {
                const data = await this.getFormTemplateOptions()
                this.formTemplates = Array.isArray(data) ? data : (data && data.data) || []
            }
            catch (e) {
                this.formTemplates = []
                console.log(e)
            }
        },
        async onFilterChange() {
            this.currentPage = 1
            await this.getFormsData()
        },
        // Everything is filtered by the API, so the query carries the lot.
        filterQuery() {
            const params = {}
            const search = (this.filterFields.search || '').trim()
            if (search) params.search = search
            this.filterKeys.forEach((key) => {
                const value = this.filterFields[key]
                if (key === 'date' || value === null || value === undefined || value === '') return
                params[key] = value
            })
            // Archived rows are submissions the API only hands over when asked.
            if (this.activeTab === 'archived') params.archived = true
            // The picker holds a [start, end] pair; the API takes them apart.
            const date = this.filterFields.date
            if (this.activeTab !== 'templates' && date && date[0]) {
                params.date_from = moment(date[0]).format('YYYY-MM-DD')
                params.date_to = moment(date[1] || date[0]).format('YYYY-MM-DD')
            }
            return Object.keys(params)
                .map((key) => `${key}=${encodeURIComponent(params[key])}`)
                .join('&')
        },
        // The label is translated off the slug, so it reads the same whether the
        // API sent "needs_review" or "Needs Review".
        statusLabel(status) {
            const key = `formsPage.status_${formStatusKey(status)}`
            const label = this.$t(key)
            return label === key ? status : label
        },
        // A draft has nobody to hand it to yet.
        isPublished,
        statusClass(status) {
            // Templates only ever read Draft or Published, so their badge is
            // narrower than the submission statuses need.
            return [
                `form-status-${formStatusTone(status)}`,
                this.activeTab === 'templates' ? 'form-status-sm' : '',
            ]
        },
        // ── BULK ACTIONS ──
        // Submissions have one endpoint for the lot; templates have none, so
        // those are deleted one at a time.
        selectedIds() {
            return this.selectedRows.map((row) => row.id)
        },
        clearSelection() {
            if (this.$refs.tableRef) this.$refs.tableRef.clearSelected()
            this.allRowsSelected = false
            this.selectedRows = []
        },
        confirmBulkDelete() {
            if (!this.selectedRows.length) return
            this.showBulkDeletePopup = true
        },
        async runBulkDelete(confirmed) {
            this.showBulkDeletePopup = false
            if (!confirmed) return
            const ids = this.selectedIds()
            if (!ids.length) return
            const templates = this.activeTab === 'templates'
            try {
                this.setLoader(true)
                if (templates) {
                    for (const id of ids) await this.deleteFormTemplate(id)
                } else {
                    await this.bulkFormSubmissions({ ids, action: 'delete' })
                }
                await this.setNotification({
                    msg: templates
                        ? this.$t('formsPage.templatesDeleted', { count: ids.length })
                        : this.$t('formsPage.formsDeleted', { count: ids.length }),
                    type: "success",
                    color: "green",
                })
                this.clearSelection()
                await this.getFormsData()
            }
            catch (e) {
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.error) || this.$t('formsPage.deleteFailed'),
                    type: "error",
                    color: "red",
                })
            }
            finally {
                this.setLoader(false)
            }
        },
        confirmBulkArchive(archiving) {
            if (!this.selectedRows.length) return
            this.bulkArchiving = archiving
        },
        async runBulkArchive(confirmed) {
            const archiving = this.bulkArchiving
            this.bulkArchiving = null
            if (!confirmed) return
            const ids = this.selectedIds()
            if (!ids.length) return
            try {
                this.setLoader(true)
                await this.bulkFormSubmissions({ ids, action: archiving ? 'archive' : 'unarchive' })
                await this.setNotification({
                    msg: archiving
                        ? this.$t('formsPage.formsArchived', { count: ids.length })
                        : this.$t('formsPage.formsUnarchived', { count: ids.length }),
                    type: "success",
                    color: "green",
                })
                this.clearSelection()
                await this.getFormsData()
            }
            catch (e) {
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.error) || this.$t('formsPage.archiveFailed'),
                    type: "error",
                    color: "red",
                })
            }
            finally {
                this.setLoader(false)
            }
        },
        openBulkDueDateModal() {
            if (!this.selectedRows.length) return
            this.bulkDueDate = null
            this.bulkDueDateError = ''
            this.$bvModal.show('modal-bulk-due-date')
        },
        async saveBulkDueDate() {
            if (!this.bulkDueDate) {
                this.bulkDueDateError = this.$t('formsPage.dueDateRequired')
                return
            }
            const ids = this.selectedIds()
            if (!ids.length) return
            try {
                this.setLoader(true)
                await this.bulkFormSubmissions({
                    ids,
                    action: 'due_date',
                    due_date: moment(this.bulkDueDate).format('YYYY-MM-DD'),
                })
                this.$bvModal.hide('modal-bulk-due-date')
                await this.setNotification({
                    msg: this.$t('formsPage.dueDatesUpdated', { count: ids.length }),
                    type: "success",
                    color: "green",
                })
                this.clearSelection()
                await this.getFormsData()
            }
            catch (e) {
                this.bulkDueDateError = typeof e === 'string' ? e : (e && e.error) || this.$t('formsPage.saveFailed')
            }
            finally {
                this.setLoader(false)
            }
        },
        showArchivePopup(item) {
            this.recordToArchive = item
        },
        // Archiving takes the row out of the Forms tab and into Archived, so the
        // list is re-read either way.
        async archiveRecord(confirmed) {
            const record = this.recordToArchive
            this.recordToArchive = null
            if (!confirmed || !record) return
            try {
                this.setLoader(true)
                await this.archiveFormSubmission({ id: record.id, archived: true })
                await this.setNotification({
                    msg: this.$t('formsPage.formArchived'),
                    type: "success",
                    color: "green",
                })
                await this.getFormsData()
            }
            catch (e) {
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.error) || this.$t('formsPage.archiveFailed'),
                    type: "error",
                    color: "red",
                })
            }
            finally {
                this.setLoader(false)
            }
        },
        confirmDelete(item) {
            this.recordToDelete = item
            this.showDeletePopup = true
        },
        // The Forms tab lists submissions and the Templates tab lists templates,
        // so the confirmed row goes to whichever endpoint owns it.
        async deleteRecord(confirmed) {
            this.showDeletePopup = false
            const record = this.recordToDelete
            this.recordToDelete = null
            if (!confirmed || !record) return
            const templates = this.activeTab === 'templates'
            try {
                this.setLoader(true)
                if (templates) await this.deleteFormTemplate(record.id)
                else await this.deleteFormSubmission(record.id)
                await this.setNotification({
                    msg: templates ? this.$t('formsPage.templateDeleted') : this.$t('formsPage.formDeleted'),
                    type: "success",
                    color: "green",
                })
                await this.getFormsData()
            }
            catch (e) {
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.error) || this.$t('formsPage.deleteFailed'),
                    type: "error",
                    color: "red",
                })
            }
            finally {
                this.setLoader(false)
            }
        },
        async getFormsData() {
            if (this.showTemplateEditor || this.showFormFill) return
            try {
                this.isBusy = true
                this.items = []
                let url = ""
                const filters = this.filterQuery()
                if (filters) url += `${filters}&`
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=name&sort_order=asc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                let data
                if (this.activeTab === "templates") data = await this.getFormTemplates(url)
                else data = await this.getUserForms(url)
                const records = data && data.data ? data.data : []

                if (this.activeTab === "templates") {
                    this.items = records.map((item) => ({
                        id: item.id,
                        name: item.name,
                        status: item.status,
                        access: item.access_count
                            ? `${item.access_label} (${item.access_count})`
                            : item.access_label,
                        field_count: item.field_count,
                    }))
                } else {
                    this.items = records.map((item) => {
                        console.log(item)
                        return {
                            id: item.id,
                            assigned_to: item.assigned_to ? item.assigned_to.name : '-',
                            form: item.template.name,
                            assigned_by: item.assigned_by ? item.assigned_by.name : '-',
                            reviewed_by: item.reviewed_by ? item.reviewed_by.name : '-',
                            submitted_at: item.submitted_at,
                            due_date: item.due_date,
                            status: item.status,
                        }
                    })
                }
                this.rows = data && data.total_entries_count ? data.total_entries_count : 0
                if (this.rows) {
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('tasksPage.positionText', { start, end, total: this.rows })
                }
                else {
                    this.positionText = this.$t('tasksPage.emptyPosition')
                }
                this.emptyTable = this.items.length === 0
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        },
    },
    watch: {
        // Leaving the builder — by the Close button or the back button — puts the
        // list back in front of a fresh fetch.
        "$route.params.templateId": {
            handler(templateId, previous) {
                if (!templateId && previous) this.getFormsData()
            },
        },
        "$route.params.submissionId": {
            handler(submissionId, previous) {
                if (!submissionId && previous) this.getFormsData()
            },
        },
        perPage: {
            async handler() {
                await this.getFormsData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getFormsData();
            },
        },
        sortBy: {
            async handler() {
                await this.getFormsData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getFormsData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
                this.rememberFilters()
            },
            deep: true
        },
    },
    async mounted() {
        this.syncTabQuery(this.activeTab);
    },
};
</script>
<style scoped>
/* DVIR's status badge, rule for rule (see .dvir-status in DVIR.vue) — only the
   uppercase is dropped. */
.form-status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 12px;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    width: 130px;
    white-space: nowrap;
}

.form-status-sm {
    width: 100px;
}

.form-status-success {
    background-color: #2cce89;
}

.form-status-primary {
    background-color: #2d69f6;
}

.form-status-warning {
    background-color: #ffc800;
}

.form-status-danger {
    background-color: #ff0000;
}

.form-status-secondary {
    background-color: #f4f4f4 !important;
    border: 1px solid #eaeaea !important;
    color: black !important;
}
</style>
